import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout/DashboardLayout';
import ProtectedRoute from './routes/ProtectedRoute';
import GuestRoute from './routes/GuestRoute';
import Register from './screens/Register/Register';
import Login from './screens/Login/Login';
import PlanSelection from './screens/PlanSelection/PlanSelection';
import StripeRedirect from './screens/StripeRedirect/StripeRedirect';
import DomainEntry from './screens/DomainEntry/DomainEntry';
import DnsVerification from './screens/DnsVerification/DnsVerification';
import Provisioning from './screens/Provisioning/Provisioning';
import Success from './screens/Success/Success';
import Home from './screens/Dashboard/Home/Home';
import Tenants from './screens/Dashboard/Tenants/Tenants';
import AgencyTemplate from './screens/AgencyTemplate/AgencyTemplate';
import Subscriptions from './screens/Dashboard/Subscriptions/Subscriptions';
import PaymentsPage from './screens/Dashboard/Payments/Payments';
import DomainProvisioning from './screens/Dashboard/DomainProvisioning/DomainProvisioning';
import ManageModule from './screens/Dashboard/manageModule/manageModule';
import { Toaster } from 'react-hot-toast';
import CreateInvoicePage from './screens/Dashboard/Tenants/createInvoicePage';
// import Subscriptions from './screens/Dashboard/Subscriptions/Subscriptions';
// import Payments from './screens/Dashboard/Payments/Payments';
// import DomainProvisioning from './screens/Dashboard/DomainProvisioning/DomainProvisioning';
// import ApiIntegrations from './screens/Dashboard/ApiIntegrations/ApiIntegrations';
// import SystemLogs from './screens/Dashboard/SystemLogs/SystemLogs';
// import Settings from './screens/Dashboard/Settings/Settings';

const App: React.FC = () => (
  <BrowserRouter>
  <Toaster />
    <Routes>
      <Route element={<GuestRoute />}>
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Home />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="domain-provisioning" element={<DomainProvisioning />} />
          <Route path="modules" element={<ManageModule />} />
          <Route path="tenant-invoice/:id" element={<CreateInvoicePage />} />
          {/* <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="payments" element={<Payments />} />
          <Route path="domain-provisioning" element={<DomainProvisioning />} />
          <Route path="api-integrations" element={<ApiIntegrations />} />
          <Route path="system-logs" element={<SystemLogs />} />
          <Route path="settings" element={<Settings />} /> */}
        </Route>
      </Route>
      {/* <Route element={<ProtectedRoute />}> */}
        <Route path="/plans" element={<PlanSelection />} />
        <Route path="/checkout" element={<StripeRedirect />} />
        <Route path="/domain-entry" element={<DomainEntry />} />
        <Route path="/verifying" element={<DnsVerification />} />
        <Route path="/provisioning" element={<Provisioning />} />
        <Route path="/success" element={<Success />} />
        <Route path="/my-site" element={<AgencyTemplate />} />
      {/* </Route> */}
      <Route element={<ProtectedRoute roles={['admin']} />}>
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<Home />} />
          <Route path="tenants" element={<Tenants />} />
          {/* <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="payments" element={<Payments />} />
          <Route path="domain-provisioning" element={<DomainProvisioning />} />
          <Route path="api-integrations" element={<ApiIntegrations />} />
          <Route path="system-logs" element={<SystemLogs />} />
          <Route path="settings" element={<Settings />} /> */}
        </Route>
      </Route>
      <Route path="/" element={<Navigate to="/register" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;